import { ReactComponent as QRCode } from './icon_qr_code.svg';
import Icon, { IconProps } from './icon';

const IconQRCode = (props: IconProps) => {
  return <Icon {...props} Svg={QRCode} />;
};

export default IconQRCode;
